export default function getResource(label) {
    const resources = {
        event: 'Event',
        free: 'FREE',
        location: 'Location',
        getDirections: 'Get Directions',
        confirmationNumber: 'Confirmation #'
    };

    return resources[label];
}
